ActivitySort =
  sortBy: ''
  sortDirection: ''
  urlWithParams: ''
  sortAndDirection: ''
  ajaxData: ''

  init: ->
    return unless $('#hidden_activity_form_fields').length
    @bindLinks()
    @retrieveParams()
    @setupData()
    @updateLinks()

  bindLinks: ->
    $('[data-sort-link]').on 'click', (event) =>
      link = $(event.target)
      @sortBy = link.data('sort-by')
      @sortDirection = link.data('sort-direction')
      @makeRequest(@setupData())
      @updateTitle(link.text())
      @updateLinks()

  retrieveParams: ->
    # This retrieves existing params from the hidden fields, so that we can
    # persist sorting across category links
    @sortBy = $("#hidden_activity_form_fields #sort").val()
    @sortDirection = $("#hidden_activity_form_fields #direction").val()

  setupData: ->
    @sortAndDirection = "sort=" + @sortBy + "&direction=" + @sortDirection
    @ajaxData = @sortAndDirection +
      "&q=" +
      $("#hidden_activity_form_fields #q").val() +
      "&category=" +
      $("#hidden_activity_form_fields #category").val()

  makeRequest: (data) ->
    $.ajax
      url: '/u/lessons'
      data: @ajaxData
      type: 'GET'
      beforeSend: (jqXHR, settings) =>
        console.log("firing beforeSend, and settings.url is : " + settings.url)
        @urlWithParams = settings.url
      success: (result) =>
        $('#user-activities-results').html(result)
        # Push the new url params into the address bar / history API
        history.pushState(null, null, @urlWithParams)

  updateTitle: (titleOfSort) ->
    $('[data-sort-title]').html(titleOfSort)

  updateLinks: ->
    if (@sortBy.length || @sortDirection.length)
      $('[data-update-after-sort]').each (index, object) =>
        oldHref = $(object).attr('href')
        $(object).attr('href', "#{oldHref}&#{@sortAndDirection}")

$(document).on 'turbo:load', ->
  if $('[data-activity-sort]').length
    ActivitySort.init()

global.ActivitySort = ActivitySort

export default ActivitySort